import styled from 'styled-components';

import { rem } from '@desygner/ui-common-components';

export const StyledPromotionalModal = styled.div`
  display: flex;
`;

export const StyledPromotionalContainer = styled.div`
  ${({ theme }) => {
    const borderRadius = rem(theme.Spacing.Size.MediumSmall);

    return `
      flex: 1;
      background: ${theme.Components.Panel.Background};
      border-radius: ${borderRadius} 0 0 ${borderRadius};
    `;
  }}
`;

const STYLED_IMAGE_PANEL_PRESETS = {
  width: 424,
};

export const StyledPromotionalImagePanel = styled.div`
  ${({ theme }) => {
    const borderRadius = rem(theme.Spacing.Size.MediumSmall);

    return `
      display: none;
      flex: 1;

      & img {
        border-radius: 0 ${borderRadius} ${borderRadius} 0;
        width: ${rem(STYLED_IMAGE_PANEL_PRESETS.width)};
      }

      @media (min-width: ${theme.Screen.Size.Medium}px) {
        display: flex;
      }
    `;
  }}
`;

export const StyledPromotionalContent = styled.div`
  ${({ theme }) => `
    padding: ${rem(theme.Spacing.Size.Large)};
    display: flex;
    flex-direction: column;
    gap: ${rem(theme.Spacing.Size.XLarge)};
    height: 100%;
    button {
      min-height: ${rem(theme.Spacing.Size.XLarge)};
    }
  `}
`;

export const StyledPromotionalTitle = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${rem(theme.Spacing.Size.XSmall)};
  `}
`;

export const StyledHighlightText = styled.span`
  ${({ theme }) => `
    color: ${theme.Color.System.Primary};
  `}
`;

export const StyledPromotionalOptionsContainer = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${rem(theme.Spacing.Size.MediumSmall)};
    height: 100%;
  `}
`;

export const StyledPromotionalOptionItemIcon = styled.div`
  ${({ theme }) => `
    width: ${rem(theme.Spacing.Size.MediumLarge)};
    min-width: ${rem(theme.Spacing.Size.MediumLarge)};
    height: ${rem(theme.Spacing.Size.MediumLarge)};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${rem(theme.Spacing.Size.Large)};
    background: ${theme.Color.Neutrals.Light};
    border: ${rem(theme.Border.Size.Large)} solid ${theme.Color.System.Primary};
    i {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: ${rem(theme.Border.Size.Large)};
      margin-top: ${rem(theme.Border.Size.Large)};
    }
  `}
`;

export const StyledPromotionalOptionItem = styled.div`
  ${({ theme }) => `
    display: flex;
    gap: ${rem(theme.Spacing.Size.XSmall)};
    .ant-space {
      margin-top: ${rem(theme.Spacing.Size.XXSmall)};
    }
  `}
`;
